export const preprocessModuleAction = () => ({
  type: 'PREPROCESS_MODULE',
  data: {},
});
